import { render, staticRenderFns } from "./updates-content.vue?vue&type=template&id=c8dc72c4"
import script from "./updates-content.vue?vue&type=script&lang=js"
export * from "./updates-content.vue?vue&type=script&lang=js"
import style0 from "./updates-content.vue?vue&type=style&index=0&id=c8dc72c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/app/node_modules/vuetify/lib/components/VIcon/VIcon.js').default,GalleryPhoto: require('/app/components/ui/GalleryPhoto.vue').default,VBtn: require('/app/node_modules/vuetify/lib/components/VBtn/VBtn.js').default})


/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
